import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { CircularProgress } from "@mui/material";
import styles from "./river-spinner.module.scss";
import clsx from "clsx";
export const RiverSpinner = ({ show, className, size, }) => (_jsx(_Fragment, { children: show && (_jsx("div", { className: clsx([styles.container, className]), "data-testid": "river-spinner-container", children: _jsx(CircularProgress, { size: size }) })) }));
